import { React, useState, useMemo, useCallback } from 'react';
import debounce from 'lodash.debounce';
// import IntlMessages from '@iso/components/utility/intlMessages';
// import Checkbox, { CheckboxGroup } from '@iso/components/uielements/checkbox';
import Box from '@iso/components/utility/box';
// import ContentHolder from '@iso/components/utility/contentHolder';
import Button from '@iso/components/uielements/button';
// import {
//     InputSearch,
//     InputGroup,
//     Textarea,
// } from '@iso/components/uielements/input';
import { useContext } from 'react';
import { Spin, Tooltip, Input } from 'antd';
// import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import awsLogo from '@iso/assets/images/icon/aws-logo.svg';
import gcpLogo from '@iso/assets/images/icon/gcp-logo.svg';
// import closeIcon from '@iso/assets/images/icon/close-icon.svg';
import CloseIcon from '@iso/assets/images/icon/07-icon.svg';
import styled, { createGlobalStyle } from 'styled-components';
import { SelectOption } from '@iso/components/uielements/select';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import initialData from '../../redux/scrumBoard/data';
import { AppContext } from '../../context/ContextProvider';
// import CreateTaskHeader from '../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
// import { borderRadius } from '../../../library/helpers/style_utils';
import Select from './AddEnvironmentVariable.style';
// import Dropzone from '@iso/components/uielements/dropzone';
// import DropzoneWrapper from '../AdvancedUI/Dropzone/Dropzone.styles';
// import Alert from '@iso/components/Feedback/Alert';
// import Scrollbars from 'react-custom-scrollbars-2';
import { AlertContext } from '../../context/alertContext';
import api from '../../api';
import { customFilterOption, customSortOptions, formatErrors, hasPermission } from '../../context/helper';
import UploadFiles from '../../components/utility/UploadFiles';
import { InfoCircleFilled } from '@ant-design/icons';
// import InputBox from '@iso/containers/Ecommerce/Checkout/InputBox.js';
// import { CustomModal } from '../Dashboard/CustomComponents/PageLoader.style';


// var ReactDOMServer = require('react-dom/server');

const Option = SelectOption;

// const marginsBot = {
//     position: 'fixed',
//     opacity: '100%',
//     transition: 'all 1s ease',
//     top: "7vw",
//     right: "0",
//     zIndex: '1000',
//     width: "25%",
//     padding: '15px'
// };

// const fadeMarginBot = {
//     position: 'fixed',
//     opacity: '0',
//     transition: 'all 1s ease',
//     top: "7vw",
//     right: "0",
//     zIndex: '-1',
//     width: "25%",
//     padding: '15px'
// };

let titleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontSize: "16px",
    fontWeight: "500"
}

let subTitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400"
}

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }

  .isoHelperText {
    color: red;
    font-weight: 400;
    font-size: 12px;
    margin-top: 30%;
    display: flex;
    justify-content: center;
  }

  .header__center {
    font-size: 15px;
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    grid-column-gap: 1.2rem;
    align-items: center;
    color: #7C7C7C;
    margin: 50px;
    margin-inline: 49px;
  }

  .header__center::before, .header__center::after {
    content: "";
    display: block;
    height: 1px;
    background-color: #F4F4F4;
  }
`;

// const addButtonStyle = {
//     marginRight: "10px",
//     fontSize: "25px"
// };

const buttonCss = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px 46px"
};

const footerStyle = {
    width: "100%",
    position: "absolute",
    bottom: "0",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "20px 10px",
    borderTop: "1px solid #B1B1B1",
    background: "#FFF",
}

export default ({
    // handleSubmit,
    data,
    // valueFromDropdown,
    update,
    service,
    selectedAppId,
    // values,
    // submitCount,
    // onCancel,
    // onDelete,
    // openDrawer,
    // onEditCancel,
    // tabSelected,
    currentProject,
    setCurrentProject,
    setHasChanges,
    fromEnvironment,
    fromWorkflow
}) => {

    console.log("ImportEnvironmentVariable props - selectedAppId:", selectedAppId, "fromEnvironment:", fromEnvironment, "service:", service);

    const { setOpenModel, openRightDrawer, setOpenRightDrawer, dispatch } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const [importData, setImportData] = useState({
        repo: service ? (service.is_private ? service.repo_name : service.repo_url) : "",
        branch: "",
        importOption: "",
        file: "",
        secretFile: "",
        uploadContent: false,
    });

    // Memoize selected service to avoid repeated find operations
    const selectedService = useMemo(() => {
        console.log("selectedService memoization - fromEnvironment:", fromEnvironment, "selectedAppId:", selectedAppId, "data:", data, "currentProject.tasks:", currentProject?.tasks);
        if (fromEnvironment && selectedAppId !== null && selectedAppId !== undefined) {
            // When fromEnvironment is true, selectedAppId is the array index (serviceIdx)
            const service = currentProject?.tasks?.find(val => val.serviceId === selectedAppId);
            console.log("Found service at index", selectedAppId, ":", service);
            return service;
        }
        console.log("selectedService returning null - fromEnvironment:", fromEnvironment, "selectedAppId:", selectedAppId);
        return null;
    }, [fromEnvironment, currentProject?.tasks, selectedAppId]);

    const selectedAccountDetails = useMemo(() => {
        return selectedService?.accountDetails;
    }, [selectedService]);

    // Get the correct account details source based on fromEnvironment (only for Secrets import)
    const getAccountDetailsSource = useMemo(() => {
        if (importData.importOption !== "Secrets") {
            return null;
        }
        if (fromEnvironment) {
            console.log("selectedAccountDetails :", selectedAccountDetails);
            console.log("currentProject :", currentProject);
            return selectedAccountDetails;
        }
        return currentProject?.accountDetails;
    }, [importData.importOption, fromEnvironment, selectedAccountDetails, currentProject?.accountDetails]);

    const [fetching, setFetching] = useState(false);
    const [repoList, setRepoList] = useState([]);
    // const [myDropdown, setMyDropdown] = useState([]);
    const [file, setFile] = useState(null);
    const [jsonData, setJsonData] = useState();
    const [parsedEnvVars, setParsedEnvVars] = useState([]);
    const [filesList, setFilesList] = useState([]);
    const [branchLoad, setBranchLoad] = useState(true);
    const [importOptions, setImportOptions] = useState([]);
    const [secretList, setSecretList] = useState([]);
    const [error, setError] = useState({
        status: false,
        msg: "Success"
    });

    // const navigate = useNavigate();
    // const location = useLocation();
    const [searchValue, setSearchValue] = useState("");
    const [secretLoad, setSecretLoad] = useState(false);
    const [secretPage, setSecretPage] = useState(1);
    const [secretHasNext, setSecretHasNext] = useState(false);
    const [secretSearch, setSecretSearch] = useState("");

    const callGitlabPublicBranchesApi = (url) => {
        fetch(url)
            .then(async (res) => await res.json())
            .then((data) => {
                console.log('branches data :', data);
                if (data.type !== "error") {
                    if (data.message) {
                        console.log("Unable to connect to gitlab. Please check if repo is public");
                        setError({
                            status: true,
                            type: "branch",
                            msg: "Unable to connect to gitlab. Please check if repo is public"
                        });
                        // toggleAlert("error", "Error", "Unable to connect to github. Please check if repo is public");
                    }
                    else {
                        let branches = [];
                        data.map((temp, ind) => {
                            branches.push(
                                <Option key={ind} name="branch" value={temp.name}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                        <span>{temp.name}</span>
                                    </div>
                                </Option>
                            );
                        });
                        setRepoList(branches);
                    }
                }
                else {
                    toggleAlert("Error", "Error", data.error?.message);
                }
                setBranchLoad(false);
            })
            .catch((error) => {
                console.error('Error fetching branches:', error);
                setBranchLoad(false);
            });
    }

    useEffect(() => {
        console.log("Executing this useEffect");
        // let options = (!fromEnvironment && !fromWorkflow) ? ["Repo", "Upload .env file", "Secrets"] : ["Repo", "Upload .env file"];
        const options = ["Repo", "Upload .env file", "Secrets"];
        const secretManagerAvailable = fromEnvironment ? selectedAccountDetails?.account_id : currentProject?.accountDetails?.account_id;

        options.forEach((val) => {
            if (!fromEnvironment) {
                if (val === "Secrets") {
                    const disabled = !secretManagerAvailable || !hasPermission('create_secret');
                    const title = !secretManagerAvailable
                        ? "Connect a Secret Manager to import secrets."
                        : (!hasPermission('create_secret') && "You don't have permission to perform this action.");
                    importOptions.push(
                        <Option key={val} name="importOption" value={val} title={title} disabled={disabled}>
                            {val}
                        </Option>
                    );
                }
                else if (currentProject.tasks[selectedAppId].app_source_type === 1 && val === "Repo") {
                    importOptions.push(<Option key={val} name="importOption" value={val}>{val}</Option>);
                }
                else if (val !== "Repo") {
                    importOptions.push(<Option key={val} name="importOption" value={val}>{val}</Option>);
                }
            }
            else {
                if (val === "Secrets") {
                    const disabled = !secretManagerAvailable || !hasPermission('create_secret');
                    const title = !secretManagerAvailable
                        ? "Connect a Secret Manager to import secrets."
                        : (!hasPermission('create_secret') && "You don't have permission to perform this action.");
                    importOptions.push(
                        <Option key={val} name="importOption" value={val} title={title} disabled={disabled}>
                            {val}
                        </Option>
                    );
                } else {
                    importOptions.push(<Option key={val} name="importOption" value={val}>{val}</Option>);
                }
            }
        });
        setImportOptions([...importOptions]);
    }, []);

    const fetchSecrets = useCallback((page, search, isLoadMore = false) => {
        if (!getAccountDetailsSource) return;

        setSecretLoad(true);
        const url = process.env.REACT_APP_API_URI + `/api/integration/secret-manager/list/secrets/${getAccountDetailsSource?.region}/${getAccountDetailsSource?.account_id}`;
        const params = {
            integration_id: getAccountDetailsSource?.integration,
            page: page,
            page_size: 10,
            search: search
        };

        api.get(url, { params })
            .then((res) => {
                let data = res.data;
                if (data.status) {
                    let newSecrets = data.data.results || [];
                    setSecretList(prev => isLoadMore ? [...prev, ...newSecrets] : newSecrets);
                    setSecretHasNext(data.data.has_next);
                    setSecretPage(data.data.page);
                } else {
                    console.log("Error");
                    setError({
                        msg: data.error_details?.error || data.message,
                        status: true
                    });
                }
                setSecretLoad(false);
            }).catch((err) => {
                console.log("Error", err);
                setSecretLoad(false);
            });
    }, [getAccountDetailsSource]);

    const debouncedFetchSecrets = useCallback(debounce((page, search) => {
        fetchSecrets(page, search);
    }, 800), [fetchSecrets]);

    const handleSecretSearch = (value) => {
        setSecretSearch(value);
        setSecretLoad(true);
        setSecretList([]);
        setSecretPage(1);
        debouncedFetchSecrets(1, value);
    }

    const handleSecretScroll = (e) => {
        const { target } = e;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 20 && !secretLoad && secretHasNext) {
             fetchSecrets(secretPage + 1, secretSearch, true);
        }
    }

    useEffect(() => {
        console.log("Import data.importOption: ", importData.importOption);
        if (importData.importOption === "Secrets" && getAccountDetailsSource) {
             setSecretList([]);
             setSecretPage(1);
             setSecretSearch("");
             fetchSecrets(1, "");
        }
    }, [importData.importOption, getAccountDetailsSource, fetchSecrets]);

    useEffect(() => {
        console.log("data in importEnvironmentVariables :", data);
        console.log("service in importEnvironmentVariables :", service);
        console.log("currentProject in importEnvironmentVariables :", currentProject);
        console.log("My import data: ", importData.importOption === "Repo");

        if (importData.importOption === "Repo") {
            if (service && !service.is_private && service.app_source_type === 1) {
                let rawData = service?.repo_url?.split("/");
                console.log("rawData :", rawData);

                if (service && !service.is_private) {
                    let rawData = service.repo_url.split("/");
                    console.log("rawData :", rawData);
                    let owner = rawData[3];
                    let repoName = rawData[4];

                    if (repoName) {
                        repoName = repoName.split(".git")[0];
                    }

                    if (service?.repo_url?.includes("https://github.com")) {
                        fetch(`https://api.github.com/repos/${owner}/${repoName}/branches`)
                            .then(async (res) => await res.json())
                            .then((data) => {
                                console.log('branches data :', data);
                                if (data.type !== "error") {
                                    if (data.message) {
                                        console.log("Unable to connect to github. Please check if repo is public.");
                                        setError({
                                            status: true,
                                            type: "branch",
                                            msg: "Unable to connect to github. Please check if repo is public."
                                        });
                                        // toggleAlert("error", "Error", "Unable to connect to github. Please check if repo is public");
                                    }
                                    else {
                                        let branches = [];
                                        data.map((temp, ind) => {
                                            branches.push(
                                                <Option key={ind} name="branch" value={temp.name}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                        <span>{temp.name}</span>
                                                    </div>
                                                </Option>
                                            );
                                        });
                                        setRepoList(branches);
                                    }
                                }
                                else {
                                    toggleAlert("Error", "Error", data.error?.message);
                                }
                                setBranchLoad(false);
                            })
                            .catch((error) => {
                                console.error('Error fetching branches:', error);
                                setBranchLoad(false);
                            });
                    }
                    else if (service && service.repo_id) {
                        // GitLab instance details
                        let gitlabInstance = `https://${rawData[2]}`;
                        let projectPath = `${owner}%2F${repoName}`;

                        let url = `${gitlabInstance}/api/v4/projects/${projectPath}/repository/branches`;
                        callGitlabPublicBranchesApi(url);
                    }
                    else if (service?.repo_url?.includes("bitbucket")) {
                        fetch(`https://api.bitbucket.org/2.0/repositories/${owner}/${repoName}/refs/branches?sort=-target.date`)
                            .then(async (res) => await res.json())
                            .then((data) => {
                                console.log('branches data :', data);
                                if (data.type !== "error") {
                                    if (data.message) {
                                        console.log("Unable to connect to bitbucket. Please check if repo is public.");
                                        setError({
                                            status: true,
                                            type: "branch",
                                            msg: "Unable to connect to bitbucket. Please check if repo is public."
                                        });
                                    }
                                    else {
                                        let branches = [];
                                        data.map((temp, ind) => {
                                            branches.push(
                                                <Option key={ind} name="branch" value={temp.name}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                                        <span>{temp.name}</span>
                                                    </div>
                                                </Option>
                                            );
                                        });
                                        setRepoList(branches);
                                    }
                                }
                                else {
                                    toggleAlert("Error", "Error", data.error?.message);
                                }
                                setBranchLoad(false);
                            })
                            .catch((error) => {
                                console.error('Error fetching branches:', error);
                                setBranchLoad(false);
                                // toggleAlert("error", "Error", "Something went wrong. Please try again.");
                            });
                    }
                    else {
                        // GitLab instance details
                        let gitlabInstance = `https://${rawData[2]}`;
                        let projectPath = `${owner}%2F${repoName}`;

                        let url = `${gitlabInstance}/api/v4/projects/${projectPath}/repository/branches`;
                        callGitlabPublicBranchesApi(url);
                    }
                }
            }
            else if (service.app_source_type === 1) {
                api.post(process.env.REACT_APP_API_URI + '/api/integration/vcs/branch/', {
                    account_id: service.account_id,
                    repo_name: service.repo_name
                }).then((res) => {
                    let data = res.data;
                    if (!data.status) {
                        let err = formatErrors(data.error_details);
                        console.log("Error :", err);
                        // toggleAlert("error", "Error", err);
                    }
                    else {
                        let branches = [];
                        data.data.map((temp, ind) => {
                            branches.push(
                                <Option key={ind} name="branch" value={temp}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "Center" }}>
                                        <span>{temp}</span>
                                    </div>
                                </Option>
                            );
                        });
                        setRepoList(branches);
                    }
                    setBranchLoad(false);
                })
                    .catch((err) => {
                        console.log("Error :", err);
                        setBranchLoad(false);
                        // toggleAlert("error", "Error", "Something went wrong. Please try again.");
                    });
            }
        }

        // get .env Files from github
        // getFilesFromRepo();
    }, [importData.importOption]);


    useEffect(() => {
        if (importData.importOption === "Repo") {
            setFetching(true);
            getFilesFromRepo();
        }
    }, [importData.branch])



    const handelClick = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
                columnId: ""
            },
        });
    }

    const getFilesFromRepo = () => {
        api.get(process.env.REACT_APP_API_URI + `/api/project_env/get_env_file/${service.serviceId}?branch=${importData.branch}`)
            .then((res) => {
                let data = res.data;
                if (!data.status) {
                    let err = formatErrors(data.error_details);
                    console.log("Error :", err);
                    setFetching(false);
                }
                else if (!data.data) {
                    setFetching(false);
                    console.log("File not found in given repo. Please try changing you branch.");
                    // toggleAlert("error", "Error", "File not found in given repo. Please try changing you branch.");
                }
                else if (data.data) {
                    let envFile = [];
                    data.data.map((temp, ind) => {
                        envFile.push(
                            <Option key={ind} name="file" value={temp.file_path}>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "Center" }}>
                                    <span>{temp.file_name}</span>
                                </div>
                            </Option>
                        );
                    });

                    setFilesList(envFile);
                    setFetching(false);
                }
            })
            .catch((err) => {
                setFetching(false);
                console.log("Error :", err);
                // toggleAlert("error", "Error", "Something went wrong. Please try again.");
            });
    }

    const parseKeyValueContent = (content, type) => {
        const entries = [];
        const seenKeys = new Set();
        const normalised = content.replace(/\r\n/g, '\n');
        let lines = normalised.split('\n');

        for (let i = 0; i < lines.length; i++) {
            let line = lines[i];

            // Handle multiline values using backslash continuation
            while (line.endsWith('\\') && i + 1 < lines.length) {
                line = line.slice(0, -1) + '\n' + lines[i + 1];
                i += 1;
            }

            if (!line || !line.trim() || line.trim().startsWith('#') || line.trim().startsWith('//')) {
                continue;
            }

            const firstEqualsIndex = line.indexOf('=');
            if (firstEqualsIndex === -1) {
                continue;
            }

            const rawKey = line.substring(0, firstEqualsIndex);
            const rawValue = line.substring(firstEqualsIndex + 1);

            const key = rawKey.trim();
            const value = rawValue;

            const hasKeySpaceError = key.startsWith(" ") || key.endsWith(" ");
            const isDuplicateInFile = seenKeys.has(key);
            const isEmptyKey = !key;
            const isEmptyValue = !value;

            const hasError = isEmptyKey || hasKeySpaceError || isDuplicateInFile;

            entries.push({
                key,
                value,
                hasError,
                reasons: {
                    isEmptyKey,
                    hasKeySpaceError,
                    isDuplicateInFile,
                    isEmptyValue,
                },
                source: type,
            });

            if (key && !seenKeys.has(key)) {
                seenKeys.add(key);
            }
        }

        return entries;
    };

    const parseJsonEnvContent = (content) => {
        let parsed;
        try {
            parsed = JSON.parse(content);
        } catch (e) {
            throw new Error("Invalid JSON. Please upload a valid JSON file.");
        }

        const entries = [];
        const seenKeys = new Set();

        const addEntry = (key, value) => {
            const normalisedKey = (key || "").toString().trim();
            const stringValue = value !== undefined && value !== null ? value.toString() : "";

            const hasKeySpaceError = normalisedKey.startsWith(" ") || normalisedKey.endsWith(" ");
            const isDuplicateInFile = seenKeys.has(normalisedKey);
            const isEmptyKey = !normalisedKey;
            const isEmptyValue = !stringValue;

            const hasError = isEmptyKey || hasKeySpaceError || isDuplicateInFile;

            entries.push({
                key: normalisedKey,
                value: stringValue,
                hasError,
                reasons: {
                    isEmptyKey,
                    hasKeySpaceError,
                    isDuplicateInFile,
                    isEmptyValue,
                },
                source: "json",
            });

            if (normalisedKey && !seenKeys.has(normalisedKey)) {
                seenKeys.add(normalisedKey);
            }
        };

        if (Array.isArray(parsed)) {
            parsed.forEach((item) => {
                if (item && typeof item === "object") {
                    if (Object.prototype.hasOwnProperty.call(item, "key") && Object.prototype.hasOwnProperty.call(item, "value")) {
                        addEntry(item.key, item.value);
                    } else {
                        Object.keys(item).forEach((k) => {
                            addEntry(k, item[k]);
                        });
                    }
                }
            });
        } else if (parsed && typeof parsed === "object") {
            Object.keys(parsed).forEach((k) => {
                addEntry(k, parsed[k]);
            });
        }

        return entries;
    };

    const handleReadFile = (file) => {
        const reader = new FileReader();
        console.log("Files :", file);
        setError({ ...error, status: false, type: undefined });
        setParsedEnvVars([]);

        reader.onload = (e) => {
            try {
                const content = e.target.result;
                const name = file?.name || "";
                const lowerName = name.toLowerCase();

                let entries = [];

                if (lowerName.endsWith('.json')) {
                    entries = parseJsonEnvContent(content);
                } else if (lowerName.endsWith('.env') || lowerName.endsWith('.txt')) {
                    entries = parseKeyValueContent(content, lowerName.endsWith('.env') ? 'env' : 'txt');
                } else {
                    const msgText = "Unsupported file format. Allowed formats: .env, .txt, .json";
                    setError({
                        status: true,
                        msg: msgText,
                    });
                    toggleAlert("error", "Error", msgText);
                    return;
                }

                if (!entries.length) {
                    const msgText = "No variables found in the selected file.";
                    setError({
                        status: true,
                        msg: msgText,
                    });
                    toggleAlert("error", "Error", msgText);
                    return;
                }

                setJsonData(content);
                setParsedEnvVars(entries);
                setImportData({ ...importData, uploadContent: true });
                toggleAlert("success", "Success", `${file.name} uploaded successfully. Please review the preview and proceed.`);
            } catch (error) {
                console.error('Error parsing environment variable file:', error);
                const msgText = error.message || "Error parsing environment variable file.";
                setError({
                    status: true,
                    msg: msgText,
                });
                toggleAlert("error", "Error", msgText);
            }
        };

        if (file) {
            setFile({
                ...file,
                uid: file.uid,
                name: file.name,
                status: 'done',
            });
            reader.readAsText(file);
        }
    };

    const handelRemoveFile = () => {
        console.log("handelRemoveFile :", file);
        eventHandlers.removedfile();
    }

    const componentConfig = {
        iconFiletypes: ['.env', '.env.sample'],   // ['.jpg', '.png', '.gif']
        method: true,
        showFiletypeIcon: false,
        uploadMultiple: false,
        maxFiles: 1,
        maxFilesize: 2, // MB
        dictMaxFilesExceeded: 'You can only upload upto 1 image',
        dictRemoveFile: 'Delete',
        dictCancelUploadConfirmation: 'Are you sure to cancel upload?',
        postUrl: 'no-url',
    };

    const djsConfig = {
        acceptedFiles: ['.env', '.env.sample'],
        autoProcessQueue: false,
        maxFiles: 1,
        uploadMultiple: true,
        // previewTemplate: (
        //     <div>
        //         <p>Selected File</p>
        //         {/* <button onClick={() => setFile(null)}>Remove File</button> */}
        //         </div>
        //   )
        // previewTemplate: ReactDOMServer.renderToStaticMarkup(
        //     <div className="dz-preview dz-file-preview">
        //       <div className="dz-details">
        //         <div className="dz-filename"><span data-dz-name="true"></span></div>
        //         <img data-dz-thumbnail="true" />
        //       </div>
        //       <div className="dz-progress"><span className="dz-upload" data-dz-uploadprogress="true"></span></div>
        //       <div className="dz-success-mark"><span>✔</span></div>
        //       <div className="dz-error-mark"><span>✘</span></div>
        //       <div className="dz-error-message"><span data-dz-errormessage="true"></span></div>
        //     </div>
        // )
    };

    const eventHandlers = {
        addedfile: (newFile) => {
            setFile(newFile);
            console.log("file in addedfile :", newFile);
            handleReadFile(newFile);
        },
        success: (newFile) => {
            console.log("newFile in success :", newFile);
            toggleAlert("success", "Success", `${newFile.name} successfully uploaded`);
        },
        error: (error) => {
            console.log("error :", error);
            toggleAlert("error", "Error", "Error in uploading File");
        },
        removedfile: (newFile) => {
            console.log("newFile in removedfile :", newFile);
            setFile(null);
        }
    };

    const handleSelectChange = (value, event) => {
        console.log("inside handleSelectChange");
        setImportData({ ...importData, [event.name]: value });
        setError({ ...error, status: false });
    }

    const handelCreate = (e, addAnother) => {
        console.log("inside handelCreate importData:", importData);
        console.log("inside handelCreate currentProject:", currentProject);

        // Already exist env varName to check for duplication in future
        let allEnvNames = [];
        let hasSecret = 0;
        service.envs.map((temp, idx) => {
            if(temp.isSecret){
                hasSecret += 1;
            }
            allEnvNames.push(temp.varName);
        });

        console.log("allEnvNames :", allEnvNames);
        if (importData.importOption === "Upload .env file") {
            if (!importData.uploadContent || !parsedEnvVars || !parsedEnvVars.length) {
                setError({
                    status: true,
                    msg: "No variables found. Please upload a valid .env, .txt, or .json file.",
                });
                return;
            }

            console.log("Parsed env vars from file:", parsedEnvVars);

            let tempEnvs = [];

            parsedEnvVars.forEach((item, idx) => {
                const key = item.key;
                const value = item.value;

                if (!key) {
                    return;
                }

                const hasKeySpaceError = key.startsWith(" ") || key.endsWith(" ");
                const isDuplicateWithExisting = allEnvNames.includes(key);
                const isEmptyValue = !value;

                const hasError = isDuplicateWithExisting || hasKeySpaceError;

                tempEnvs.push({
                    varName: key,
                    valueFrom: "Value",
                    originalKey: key,
                    value: value,
                    isSecret: false,
                    dependOn: null,
                    error: hasError,
                    id: idx,
                    isHide: false,
                    key: idx,
                    keys: key,
                    syncProj: false,
                    injectAt: fromWorkflow ? ["Build Time"] : ["Run Time"],
                    isNew: true,
                });

                allEnvNames.push(key);
            });

            if (!tempEnvs.length) {
                setError({
                    status: true,
                    msg: "No valid variables found to import.",
                });
                return;
            }

            console.log("tempEnvs :", tempEnvs);

            currentProject.importDetails = {
                ...importData
            };

            currentProject.tasks.map((temp, idx) => {
                if (temp.id === data.id) {
                    currentProject.tasks[idx].importDetails = {
                        ...importData
                    };
                    service.envs.unshift(...tempEnvs);
                    currentProject.tasks[idx].envs = service.envs;
                }
            });

            setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
            localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
            setHasChanges(true);
            handelClick();
        }
        else if (importData.importOption === "Repo") {
            if (!importData.repo) {
                setError({
                    status: true,
                    msg: "Repo name not found. Please try again"
                });
            }
            else if (!importData.repo || !importData.branch || !importData.file) {
                setError({
                    status: true,
                    msg: "Please Fill all fields marked with *"
                });
            }
            else {
                setError({ ...error, status: false });
                console.log("current project in add...", currentProject, data);
                dispatch({ loader: "secretsLoad", status: "loading" });
                // api.get(process.env.REACT_APP_API_URI + `/api/project_env/get_env_var/${service.serviceId}${importData.branch ? `/${importData.branch}/` : "/"}${importData.file ? `?file_path=${importData.file}` : ""}`)
                api.get(process.env.REACT_APP_API_URI + `/api/project_env/get_env_var/${service.serviceId}?branch=${importData.branch}&file_path=${importData.file}`)
                    .then((res) => {
                        let data = res.data;
                        console.log("data in get_env_file api :", data);
                        if (!data.status) {
                            let err = formatErrors(data.error_details);
                            toggleAlert("error", "Error", err);
                        }
                        else {
                            if (data.data) {
                                let tempEnvs = [];

                                data.data.map((temp, idx) => {
                                    let key = Object.keys(temp)[0].trim();
                                    let value = Object.values(temp)[0];

                                    // if (allEnvNames.includes(key)) {
                                    //     service.envs.map((obj, idx) => {
                                    //         if (obj.varName === key) {
                                    //             service.envs[idx].value = value;
                                    //             service.envs[idx].valueFrom = "Value";
                                    //             service.envs[idx].isSecret = false;
                                    //             service.envs[idx]["dependOn"] = null;
                                    //         }
                                    //     });
                                    // }
                                    // else {
                                    tempEnvs.push({
                                        varName: key,
                                        originalKey: key,
                                        valueFrom: "Value",
                                        value: value,
                                        isSecret: false,
                                        isHide: false,
                                        dependOn: null,
                                        error: allEnvNames.includes(key) ? true : false,
                                        id: idx,
                                        isHide: false,
                                        key: idx,
                                        keys: key,
                                        syncProj: false,
                                        isNew: true,
                                        injectAt: fromWorkflow ? ["Build Time"] : ["Run Time"]
                                        // isSecretManager
                                    });
                                    allEnvNames.push(key);
                                    // }
                                });

                                // console.log("tempEnvs :", tempEnvs);

                                currentProject.importDetails = {
                                    ...importData
                                };

                                // currentProject.accountDetails = {
                                //     ...currentProject.accountDetails,
                                //     // secret_name: importData.secretFile
                                // };

                                currentProject.tasks.map((temp, idx) => {
                                    if (temp.id === service.id) {
                                        service.envs.unshift(...tempEnvs);
                                        currentProject.tasks[idx].envs = service.envs;
                                        currentProject.tasks[idx].importDetails = {
                                            ...importData
                                        };
                                    }
                                });

                                setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
                                localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
                                setHasChanges(true);
                                handelClick();
                            }
                            else {
                                toggleAlert("error", "Error", ".env file not found. Please try different branch.");
                            }
                        }
                        dispatch({ loader: "secretsLoad", status: "loaded" });
                    })
                    .catch((err) => {
                        console.log("Error :", err);
                        toggleAlert("error", "Error", "Something went wrong. Please try again.");
                        dispatch({ loader: "secretsLoad", status: "loaded" });
                    });
            }
        }
        else if (importData.importOption === "Secrets") {
            if (importData.secretFile === "") {
                setError({
                    status: true,
                    msg: "Please Fill all fields marked with *"
                });
            }
            else {
                dispatch({ loader: "secretsLoad", status: "loading" });
                api.get(process.env.REACT_APP_API_URI + `/api/project_env/secrets?region=${getAccountDetailsSource?.region}&account_id=${getAccountDetailsSource?.account_id}&secret_name=${importData.secretFile}&integration_id=${getAccountDetailsSource?.integration}`)
                    .then((res) => {
                        let data = res.data;
                        console.log("data in get_env_file api :", data);
                        if (!data.status) {
                            let err = formatErrors(data.error_details);
                            setError({
                                msg: err,
                                status: true
                            });
                            //toggleAlert("error", "Error", err);
                        }
                        else {
                            if (data.data && Object.keys(data.data).length > 0) {
                                let tempEnvs = [];

                                let convertEnvs = [];

                                Object.keys(data.data).forEach((val) => {
                                    convertEnvs.push({
                                        [val]: data.data[val]?.toString() || ""
                                    });
                                });

                                convertEnvs.map((temp, idx) => {
                                    let key = Object.keys(temp)[0];
                                    let value = Object.values(temp)[0];

                                    // if (allEnvNames.includes(key)) {
                                    //     service.envs.map((obj, idx) => {
                                    //         if (obj.varName === key) {
                                    //             service.envs[idx].value = value;
                                    //             service.envs[idx].valueFrom = "Value";
                                    //             service.envs[idx].isSecret = true;
                                    //             service.envs[idx]["dependOn"] = null;
                                    //             service.envs[idx]["importFrom"] = "Secret Manager";
                                    //         }
                                    //     });
                                    // }
                                    // else {
                                    tempEnvs.push({
                                        varName: key,
                                        originalKey: key,
                                        valueFrom: "Value",
                                        value: value,
                                        isSecret: true,
                                        isHide: true,
                                        dependOn: null,
                                        importFrom: "Secret Manager",
                                        error: allEnvNames.includes(key) ? true : false,
                                        injectAt: ["Run Time"],
                                        id: idx,
                                        key: idx,
                                        keys: key,
                                        syncProj: false,
                                        isNew: true,
                                    });
                                    allEnvNames.push(key);
                                    // }
                                });

                                console.log("tempEnvs :", tempEnvs);

                                currentProject.importDetails = {
                                    ...importData
                                };

                                if (fromEnvironment) {
                                    // Update the specific service's account details
                                    currentProject.tasks.map((temp, idx) => {
                                        if (temp.id === service.id) {
                                            currentProject.tasks[idx].accountDetails = {
                                                ...currentProject.tasks[idx].accountDetails,
                                                // secret_name: importData.secretFile
                                            };
                                        }
                                    });
                                } else {
                                    // Update project-level account details
                                    currentProject.accountDetails = {
                                        ...currentProject.accountDetails,
                                        // secret_name: importData.secretFile
                                    };
                                }

                                currentProject.tasks.map((temp, idx) => {
                                    if (temp.id === service.id) {
                                        // currentProject.tasks[idx].importDetails = {
                                        //     ...importData
                                        // };
                                        // currentProject.tasks[idx].accountDetails = {
                                        //     ...currentProject.tasks[idx].accountDetails,
                                        //     secret_name: importData.secretFile
                                        // };
                                        if(!fromEnvironment && !fromWorkflow){
                                          currentProject.tasks[idx].secret_name = importData.secretFile;
                                        }
                                        // currentProject.tasks[idx].secret_name = importData.secretFile;
                                        service.envs.unshift(...tempEnvs);
                                        currentProject.tasks[idx].envs = service.envs;
                                        currentProject.tasks[idx].importDetails = {
                                            ...importData
                                        };
                                    }
                                });

                                // open secret_name pop up if first time added env_vars
                                // if(fromEnvironment && getAccountDetailsSource !== "Atmosly" && hasSecret == 0) {
                                //     let secretName = currentProject.tasks.find(val => val.id === service.id)?.secret_name;
                                //     console.log("secretName :", secretName);
                                //     setOpenModel({
                                //         modalType: 'CHANGE_SECRET_NAME',
                                //         modalProps: {
                                //             data: {
                                //                 name: secretName
                                //             },
                                //             title: "Change Secret Name",
                                //             subTitle: "",
                                //             cancelButton: "Cancel",
                                //             saveButton: "Change",
                                //             onChange: (taskName) => {
                                //                 console.log("onChange :", taskName);
                                //                 currentProject.tasks.map((temp, idx) => {
                                //                     if (temp.id === service.id) {
                                //                         // let tempEnvData = {...envData}
                                //                         currentProject.tasks[idx].secret_name = taskName;
                                //                     }
                                //                 });
                            
                                //                 setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
                                //                 localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
                                                
                                //                 // Close this if user confirmed execution
                                //                 setOpenModel({
                                //                     modalType: false,
                                //                     modalProps: {
                                //                         data: ""
                                //                     },
                                //                 });
                                //             },
                                //             handleCancel: () => { 
                                //                 console.log("onCancel");
                                //                 setOpenModel({
                                //                 modalType: false,
                                //                 modalProps: {
                                //                     data: ""
                                //                 },
                                //                 });
                                //             },
                                //             columnId: null,
                                //             className: "large-Box"
                                //         },
                                //     });
                                // }
                                // else if(fromWorkflow && currentProject?.accountDetails !== "Atmosly" && hasSecret == 0) {
                                //     let secretName = currentProject?.accountDetails?.secret_name;
                                //     console.log("secretName :", secretName);
                                //     setOpenModel({
                                //         modalType: 'CHANGE_SECRET_NAME',
                                //         modalProps: {
                                //             data: {
                                //                 name: secretName
                                //             },
                                //             title: "Change Secret Name",
                                //             subTitle: "",
                                //             cancelButton: "Cancel",
                                //             saveButton: "Change",
                                //             onChange: (taskName) => {
                                //                 console.log("onChange :", taskName);
                                //                 currentProject.accountDetails.secret_name = taskName;
                            
                                //                 setCurrentProject({ ...currentProject });
                                //                 localStorage.setItem("Project", JSON.stringify({ ...currentProject }));
                                                
                                //                 // Close this if user confirmed execution
                                //                 setOpenModel({
                                //                     modalType: false,
                                //                     modalProps: {
                                //                         data: ""
                                //                     },
                                //                 });
                                //             },
                                //             handleCancel: () => { 
                                //                 console.log("onCancel");
                                //                 setOpenModel({
                                //                 modalType: false,
                                //                 modalProps: {
                                //                     data: ""
                                //                 },
                                //                 });
                                //             },
                                //             columnId: null,
                                //             className: "large-Box"
                                //         },
                                //     });
                                // }
                                
                                // update current project to update
                                setCurrentProject({ ...currentProject, tasks: [...currentProject.tasks] });
                                localStorage.setItem(!fromEnvironment ? "Project" : "ProjectDep", JSON.stringify({ ...currentProject, tasks: [...currentProject.tasks] }));
                                setHasChanges(true);
                                handelClick();
                            }
                            else {
                                //toggleAlert("error", "Error", "No secrets found.");
                                setError({
                                    status: true,
                                    msg: "No secrets found."
                                });
                            }
                        }
                        dispatch({ loader: "secretsLoad", status: "loaded" });
                    })
                    .catch((err) => {
                        console.log("Error :", err);
                        toggleAlert("error", "Error", "Something went wrong. Please try again.");
                        dispatch({ loader: "secretsLoad", status: "loaded" });
                    });
            }
        }
    }

    function toggleAlert(type, message, description, hide = true, time = 5) {
        set_alertOptions(alertOptions => ({
            status: true,
            type: type,
            message: message,
            description: description,
        }));

        if (hide) {
            // opacity=0 after 10sec
            setTimeout(() => {
                set_alertOptions(alertOptions => ({
                    status: false,
                    type: type,
                    message: message,
                    description: description,
                }));
            }, time * 1000);
        }
    }

    const filterOption = (input, option) => {
        if (option.key) {
            return (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());
        }
    }

    return (
        <>
            {/* <Alert
                message={alertOptions.message}
                description={alertOptions.description}
                type={alertOptions.type}
                showIcon
                style={alertOptions.status ? marginsBot : fadeMarginBot}
            /> */}

            {/* <CustomModal
                visible={loadingSecrets}
                //onCancel={hideModal}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                style={{ border: "none", boxShadow: "none" }}
            >
                <div style={{ textAlign: 'center', background: "transparent", border: "none" }}>
                    <Spin size="large" />
                </div>
            </CustomModal> */}

            <ProdContentHold className='addEnvVar' style={{}}>
                <Box
                    title="Select to import*"
                    subtitle=""
                    titleStyle={titleStyle}
                    subtitleStyle={subTitleStyle}
                    style={{ paddingInline: "49px", marginTop: "105px" }}
                >
                    {/* {console.log("Import options: ", importOptions)} */}
                    <Select
                        data-testid="env-var-import-option-select"
                        value={importData.importOption}
                        onChange={handleSelectChange}
                        className="custom-ant-selector"
                        placeholder="Select"
                    //filterOption={filterOption}
                    //notFoundContent={branchLoad ? <Spin size="small" /> : null}
                    >
                        {importOptions}
                    </Select>
                </Box>
                {/* Header */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "rgb(19, 47, 68)" }}>
                    <Box
                        title={
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "14px"
                            }}>
                                <span className="header-text">Import Variable</span>
                                <img src={CloseIcon} style={{ cursor: "pointer", width: "20px", height: "20px", transform: "translateY(15px)" }} alt="close Icon" onClick={handelClick} />
                            </div>
                        }
                        subtitle="Enter details to import new variable"
                        titleStyle={{
                            fontWeight: '500',
                            fontFamily: "Nunito Sans",
                            fontSize: '14px',
                            color: "#ffffff"
                        }}
                        subTitleStyle={{
                            fontWeight: '400',
                            fontFamily: "Nunito Sans",
                            fontSize: '13px',
                            color: "#ffffff"
                        }}
                        style={{
                            // paddingLeft: "20px",
                            position: "absolute",
                            zIndex: "1",
                            width: "100%",
                            top: "0px",
                            height: "83px",
                            backgroundColor: "rgb(19, 47, 68)"
                        }}
                    />
                </div>
                {/* Content */}
                {importData.importOption === "Repo" && <>
                    <div style={{ opacity: file ? "0.7" : "1", pointerEvents: file && "none" }}>
                        <Box
                            title="Repo*"
                            subtitle="Repo Details"
                            titleStyle={titleStyle}
                            subtitleStyle={subTitleStyle}
                            style={{ paddingInline: "49px" }}
                        >
                            <Input
                                name="repo"
                                value={importData.repo}
                                placeholder="Repo name"
                                disabled={true}
                                style={{
                                    width: "100%",
                                    height: "44px",
                                    border: `1px solid ${error.status && error.type && error.type === "branch" ? `#f64744` : `#D0D5DD`}`,
                                    borderRadius: "8px",
                                    cursor: "not-allowed",
                                    color: "rgba(0, 0, 0, 0.25)",
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                }}
                            />
                            {error.status && error.type && error.type === "branch" && <p className="isoHelperText" style={{ marginTop: "5px", justifyContent: "start" }}>
                                <span>{error.msg}</span>
                            </p>}
                        </Box>

                        <Box
                            title="Branch*"
                            subtitle="Branch details"
                            titleStyle={titleStyle}
                            subtitleStyle={subTitleStyle}
                            style={{ paddingInline: "49px" }}
                        >
                            <Select
                                showSearch
                                filterSort={(optionA, optionB) => customSortOptions(optionA, optionB, searchValue)} // Custom sorting function
                                filterOption={(inputValue, option) => customFilterOption(inputValue, option)} // Custom filtering function
                                onSearch={(value) => {
                                    console.log("Enters search", value);
                                    setSearchValue(value);
                                }}
                                value={importData.branch}
                                onChange={handleSelectChange}
                                className="custom-ant-selector"
                                placeholder="Select"
                                style={{}}
                                //filterOption={filterOption}
                                notFoundContent={branchLoad ? <Spin size="small" /> : null}
                            >
                                {repoList}
                            </Select>
                        </Box>

                        {importData.branch && <Box
                            title={<Tooltip title={"File needs to be on the root directory."} placement="bottomLeft">
                                <div style={{ display: "flex" }}><p style={{ marginRight: "10px" }}>File*</p> <InfoCircleFilled style={{ color: "#8896A1" }} /></div>
                            </Tooltip>}
                            titleStyle={titleStyle}
                            style={{ paddingInline: "49px" }}
                        >
                            <Select
                                value={importData.file}
                                onChange={handleSelectChange}
                                placeholder="Select"
                                className="custom-ant-selector"
                            >
                                {fetching ?
                                    <Option>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                            <Spin size="small" />
                                        </div>
                                    </Option>
                                    :
                                    filesList
                                }
                            </Select>
                        </Box>}
                    </div>
                </>}
                {/* <div className='header__center'> or </div> */}


                {importData.importOption === "Secrets" && <>
                    <Box title="Provider*"
                        subtitle="Select Provider from here"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{ paddingInline: "49px" }}
                    >
                        <Input style={{ height: "44px" }} disabled prefix={<img src={getAccountDetailsSource?.integration == 3 ? gcpLogo : (getAccountDetailsSource !== "Atmosly" ? awsLogo : "")} style={{ width: "18px", height: "18px", marginRight: "10px" }} alt="provider" />} value={getAccountDetailsSource?.account_id ? getAccountDetailsSource?.account_id + " | Secret Manager" : getAccountDetailsSource} />
                    </Box>
                    {getAccountDetailsSource !== "Atmosly" && <Box title="Region*"
                        subtitle="Select region from here"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{ paddingInline: "49px" }}
                    >
                        <Input style={{ height: "44px" }} disabled value={getAccountDetailsSource?.region ? getAccountDetailsSource?.region : ""} />
                    </Box>}
                    <Box title="Select Secret*"
                        subtitle="Select Secret from here"
                        titleStyle={titleStyle}
                        subtitleStyle={subTitleStyle}
                        style={{ paddingInline: "49px" }}
                    >
                        {console.log("secrets fetched: ", secretList)}
                        <Select value={importData.secretFile}
                            onChange={handleSelectChange}
                            placeholder="Select"
                            className="custom-ant-selector"
                            showSearch
                            onSearch={handleSecretSearch}
                            onPopupScroll={handleSecretScroll}
                            filterOption={false}
                            loading={secretLoad}
                            notFoundContent={secretLoad && secretPage === 1 ? <Spin size='small' /> : (secretList?.length <= 0 ? "No secrets found" : null)}
                        >
                            {secretList.map((val) => (
                                <Option name="secretFile" key={val} value={val}>
                                    {val}
                                </Option>
                            ))}
                            {secretLoad && secretList.length > 0 && (
                                <Option key="loading" disabled>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Spin size="small" />
                                    </div>
                                </Option>
                            )}
                        </Select>
                    </Box>
                </>}

                {importData.importOption === "Upload .env file" && <Box
                    title="Upload environment variable file here*"
                    subtitle="Supported formats: .env, .txt, .json (max 2 MB)"
                    subtitleStyle={subTitleStyle}
                    titleStyle={titleStyle}
                    style={{ paddingInline: "49px" }}
                >
                    <div style={{ padding: "10px 0" }}>
                        <UploadFiles data-testid="env-var-upload-file-input"
                            types={[".env", ".ENV", ".txt", ".TXT", ".json", ".JSON"]}
                            maxSize={2 * 1024 * 1024}
                            files={file ? [file] : []}
                            setFiles={setFile}
                            handleReadFile={handleReadFile}
                            onFileRemove={() => {
                                setParsedEnvVars([]);
                                setJsonData(null);
                                setImportData({ ...importData, uploadContent: false });
                                setError({ status: false, msg: "Success" });
                            }}
                        />
                    </div>

                    {parsedEnvVars && parsedEnvVars.length > 0 && (
                        <div style={{ marginTop: "20px" }}>
                            <p style={{ ...subTitleStyle, marginBottom: "8px" }}>Preview ({parsedEnvVars.length} variables)</p>
                            <div
                                style={{
                                    border: "1px solid #D0D5DD",
                                    borderRadius: "8px",
                                    maxHeight: "200px",
                                    overflow: "auto",
                                    fontFamily: "monospace",
                                    fontSize: "12px",
                                    padding: "8px 12px",
                                    background: "#F9FAFB",
                                }}
                            >
                                {parsedEnvVars.map((item, index) => {
                                    const getErrorText = () => {
                                        if (!item.hasError) return "";
                                        if (item.reasons?.isEmptyKey) return "Empty Key";
                                        if (item.reasons?.hasKeySpaceError) return "Space Error";
                                        if (item.reasons?.isDuplicateInFile) return "Duplicate";
                                        return "Invalid";
                                    };

                                    return (
                                        <div
                                            key={`${item.key}-${index}`}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: "4px",
                                                color: item.hasError ? "#D92D20" : "#101828",
                                            }}
                                        >
                                            <span style={{ marginRight: "8px", whiteSpace: "nowrap" }}>{item.key} =</span>
                                            <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.value}</span>
                                            {item.hasError && (
                                                <span style={{ marginLeft: "8px", fontSize: "11px" }}>{getErrorText()}</span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </Box>}

                {console.log("Errors: ", error)}

                {error.status && !error.type && <p className="isoHelperText" style={{ marginTop: "0" }}>
                    <span>{error.msg}</span>
                </p>}

                <div style={{ marginBottom: "100px" }}></div>


                {/* Footer */}
                <div style={footerStyle}>
                    {!update ?
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button className="customButton" style={{ ...buttonCss, marginRight: "30px" }} onClick={() => {
                                setImportData({
                                    ...importData,
                                    branch: "",
                                    file: "",
                                    uploadContent: false,
                                });
                                handelClick();
                                console.log("Clicked Cancel");
                            }}>
                                Cancel
                            </Button>
                            <Button data-testid="env-var-import-proceed-btn" className="customButtonActive" style={{ ...buttonCss, background: "#132F44", borderRadius: "8px", color: "#FFFFFF" }} onClick={(e) => handelCreate(e, true)}>
                                Proceed
                            </Button>
                        </div>
                        :
                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button className="customButton" style={{ ...buttonCss, marginRight: "30px" }} onClick={() => { }}>
                                Cancel
                            </Button>
                            <Button className="customButtonActive" style={{ ...buttonCss, background: "#132F44", borderRadius: "8px", color: "#FFFFFF" }} onClick={() => { }}>
                                Update
                            </Button>
                        </div>
                    }
                </div>

            </ProdContentHold>
        </>
    );
};